module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('scroll', {
    staticClass: "bedsInfo",
    style: ({
      top: _vm.top
    }),
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('div', {
    staticClass: "beds-header"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('td', {
    staticClass: "f-minor"
  }, [_vm._v("病房科室")]), _vm._v(" "), _c('td', {
    staticClass: "f-minor"
  }, [_vm._v("总床位数")]), _vm._v(" "), _c('td', {
    staticClass: "f-minor"
  }, [_vm._v("剩余床位数")])])])]), _vm._v(" "), _c('no-record', {
    attrs: {
      "condition": _vm.bedsInfo,
      "tips": "暂无数据"
    }
  }), _vm._v(" "), _vm._l((_vm.bedsInfo), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "bedsInfo-container"
    }, [_c('table', {
      staticClass: "table"
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(item.deptName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.totalNum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.restNum))])])])])])
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-tips",
    attrs: {
      "id": "message-tips"
    }
  }, [_c('p', [_vm._v("温馨提示：床位数实时变动，请以医院实际床位数为准。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3ed9092","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/beds/BedsInfo.vue
// module id = 870
// module chunks = 0